module.exports = __webpack_public_path__ + "04_long_brown.5a8fe55a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_long_brown.png
// module id = Yz/O
// module chunks = 0